import React from 'react';
import { useLocation } from "react-router-dom";
const Footer = () => {
  let location = useLocation();
  if (location.pathname == '/login') {
    return <></>;
  } else {
    return (
      <div className='footer'>
          &copy; 2016-2023 - UnisLink
      </div>
    );
  }
}
export default Footer;